import * as React from 'react';
import { FComponent } from '../../../types/common';
import ChevronRightIcon from '../Icons/ChevronRightIcon';

type BreadCrumbProps = {
  crumbs: Crumb[];
};

export type Crumb = {
  name: string;
  path?: string;
};

const Breadcrumb: FComponent<BreadCrumbProps> = ({ crumbs }) => {
  return (
    <div className="breadcrumb">
      {crumbs.map(({ name, path }, index) => {
        return (
          <div key={name} className="crumb">
            <span>
              {path ? (
                <a href={path} className="back-tag">
                  {name}
                </a>
              ) : (
                <p>{name}</p>
              )}
            </span>
            {index < crumbs.length - 1 ? (
              <ChevronRightIcon className="breadcrumb-divider" />
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export { Breadcrumb };
